import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Page, Header } from 'components';

import TrxReductionForm from './components/TrxReductionForm.js';
import AlarmsDiffForm from './components/AlarmsDiffForm.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const TrxReduction = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Scripts">
			<Header module="Scripts" view="TRX Reduction" />
			<div className={clsx(classes.container)}>
				<TrxReductionForm />
				<AlarmsDiffForm />
			</div>
		</Page>
	);
};

export default TrxReduction;
